import React, { Fragment } from 'react';
import { CheckIcon } from 'lucide-react';
import { MapContainer, TileLayer, Circle, CircleMarker, Tooltip as LeafletTooltip } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import { SectionHeading } from './Section';
import { reachClusters, reachSummary, placements, placementsNote } from '../../../data/reportPhilly';
const CAB = '#6a1739';
// The targeted-reach map (Greater Philadelphia) on the left, with the
// ad-placement checklist on the right. Square corners throughout.
export function TargetedArea() {
  const home = reachClusters[0];
  return <section data-id="element-820" data-mp="1mt5rzgkqby2j">
      <SectionHeading eyebrow="Where buyers are" title="Targeted marketing area" description={reachSummary.note} data-id="element-821" data-mp="1mtp6enb684bt" />
      <div className="grid gap-5 lg:grid-cols-[1.5fr_1fr]" data-id="element-822" data-mp="1hvw3c355zqfr">
        {/* real map + cluster list */}
        <div className="space-y-4" data-id="element-823" data-mp="2y9m87c43yiqg">
          <div className="overflow-hidden border border-border shadow-sm" data-id="element-824" data-mp="2t9hqjirgrhyn">
            <MapContainer center={[home.lat, home.lng]} zoom={9} scrollWheelZoom={false} style={{
            height: '360px',
            width: '100%'
          }} attributionControl={false} data-id="element-825" data-mp="d8vghqsv1s9d">
              <TileLayer url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png" data-id="element-826" data-mp="m7qjku0lym8g" />

              <Circle center={[home.lat, home.lng]} radius={reachSummary.primaryRadiusMiles * 1609.34} pathOptions={{
              color: CAB,
              weight: 1,
              dashArray: '4 6',
              fillColor: CAB,
              fillOpacity: 0.03
            }} data-id="element-827" data-mp="r6aa77q5cm75" />

              {reachClusters.map(c => <Fragment key={c.name} data-id="element-828" data-mp="37027jb3uovlh">
                  <Circle center={[c.lat, c.lng]} radius={c.radiusMiles * 1609.34} pathOptions={{
                color: CAB,
                weight: 0,
                fillColor: CAB,
                fillOpacity: 0.05 + c.intent / 100 * 0.22
              }} data-id="element-829" data-mp="36yzh14afwv63" />
                  <CircleMarker center={[c.lat, c.lng]} radius={c.name.includes('home') ? 8 : 6} pathOptions={{
                color: '#fff',
                weight: 2,
                fillColor: CAB,
                fillOpacity: 1
              }} data-id="element-830" data-mp="3doil0l2q1lvd">
                    <LeafletTooltip direction="top" offset={[0, -6]} data-id="element-831" data-mp="2gzt16p7jaj6r">
                      <span className="text-xs font-medium" data-id="element-832" data-mp="2uz2jpvj7ppdw">
                        {c.name} · {c.intent}% interest
                      </span>
                    </LeafletTooltip>
                  </CircleMarker>
                </Fragment>)}
            </MapContainer>
          </div>

          <div className="border border-border bg-card p-5" data-id="element-833" data-mp="57nt20ngplw2">
            <p className="text-sm font-semibold" data-id="element-834" data-mp="1n5aqsioxky19">Top buyer clusters</p>
            <div className="mt-3 flex flex-col gap-2.5" data-id="element-835" data-mp="1n85841cne2qg">
              {reachClusters.map(c => <div key={c.name} className="flex items-center gap-3" data-id="element-836" data-mp="1s2j0duw0jtqw">
                  <span className="size-2.5 shrink-0 rounded-full bg-bhhs-cab" data-id="element-837" data-mp="1e6ypnmqfuhuk" />
                  <span className="flex-1 truncate text-sm" data-id="element-838" data-mp="1j507y5g1id4z">
                    {c.name.replace(' (home)', '')}
                  </span>
                  <div className="h-1.5 w-20 overflow-hidden rounded-full bg-muted" data-id="element-839" data-mp="26w5o6lpw77ft">
                    <div className="h-full rounded-full bg-bhhs-cab" style={{
                  width: `${c.intent}%`
                }} data-id="element-840" data-mp="2aullpjjlny7h" />
                  </div>
                  <span className="w-9 text-right text-xs font-medium tabular-nums text-muted-foreground" data-id="element-841" data-mp="2psxbr7cgw8po">
                    {c.intent}%
                  </span>
                </div>)}
            </div>
          </div>
        </div>

        {/* ad placements */}
        <div data-id="element-842" data-mp="15v6sqmcf73tx">
          <p className="mb-3 text-xs font-semibold uppercase tracking-[0.14em] text-bhhs-cab" data-id="element-843" data-mp="10yq31npkoheq">
            Ad placements
          </p>
          <ul className="space-y-2" data-id="element-844" data-mp="wxwhh0zlrep0">
            {placements.map(p => <li key={p.name} className={`flex items-center justify-between px-3.5 py-2.5 text-sm ${p.featured ? 'border border-bhhs-cab/30 bg-bhhs-cab/[0.03] font-semibold text-foreground' : 'text-foreground'}`} data-id="element-845" data-mp="rybdgc5ksg5f">
                <span className="flex items-center gap-2.5" data-id="element-846" data-mp="1kotfrayh6dhs">
                  <span className="size-2 rounded-full bg-bhhs-cab/50" data-id="element-847" data-mp="1fufrdsi8d6mm" />
                  {p.name}
                </span>
                <CheckIcon className="size-4 text-bhhs-cab" data-id="element-848" data-mp="1awe04kani102" />
              </li>)}
          </ul>
          <p className="mt-3 text-xs italic text-muted-foreground" data-id="element-849" data-mp="28e4lz7ylh03b">
            {placementsNote}
          </p>
        </div>
      </div>
    </section>;
}